import { useNavigate } from 'react-router-dom';

import { LoginForm } from './LoginForm';
// import LoginGoogle from 'components/LoginGoogle';
// import LoginFacebook from 'components/LoginFacebook';

export function LoginBody() {
  const navigate = useNavigate();

  return (
    <>
      <div className='flex flex-col items-center'>
        <h1 className="text-2xl font-medium mb-5">Crafttatva Artist Login</h1>
        {/* <div className='flex w-full gap-6'>
          <LoginGoogle />
          <LoginFacebook />
        </div>
        <div className='w-full flex items-center gap-4 mt-6 mb-6'>
          <hr className='grow bg-gray-200 border-t dark:bg-gray-700' />
          <span className='text-xs text-gray-600 dark:text-gray-300'>Or LogIn Using Email</span>
          <hr className='grow bg-gray-200 border-t dark:bg-gray-700' />
        </div> */}
        <LoginForm />
        <span className='block mt-4 text-sm font-light'>
          Create your Seller <b className='font-semibold'>Artist / Gallery</b> account
          <button onClick={() => navigate('/register')} className='ms-1 font-semibold text-red-700 underline cursor-pointer'>Register Now</button>
        </span>
        <span className='block mt-4 text-sm font-light'>
          Don't remember your password account?
          <button onClick={() => navigate('/forgotPassword')} className='ms-1 font-semibold text-red-700 underline cursor-pointer'>Forgot Password</button>
        </span>
      </div>
    </>
  );
}
